import React, { Component } from 'react';
import { Button, Header, Icon, Input, Modal } from "semantic-ui-react";

/** Render a list of fees sorted by percentage in descending order */
class ContactDetails extends Component { 
    constructor(props) {
        super(props);

        this.state = {
            showDialog: false,
            name: '',
            nameValid: false,
            nameErr: false,
            email: '',
            emailValid: false,
            emailErr: false,
            phone: '',
        }
    }

    showDialog = () => this.setState({ showDialog: true })
    hideDialog = () => this.setState({ showDialog: false, nameErr: false, emailErr: false })

    /**
     * Validate the name and email inputs
     * @param {*} e React's original SyntheticEvent
     * @param {*} ctl The inputs props and a proposed value
     */
    onInputChange = (e, ctl) => {
        if (ctl.name === 'name') {
            this.setState({
                name: ctl.value,
                nameValid: ctl.value.length > 0
            });
        } else if(ctl.name === 'email') {
            this.setState({
                email: ctl.value,
                emailValid: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(ctl.value)
            });
        } else if(ctl.name === 'phone') {
            this.setState({
                phone: ctl.value,
            });
        }
    };

    /**
     * When the user clicks the dialogs Send button
     */
    onComplete = () => {

        // Check if a valid user's name was entered.
        if (!this.state.nameValid) {
            this.setState({nameErr: true});
            return;
        } else {
            this.setState({nameErr: false});
        }

        // Check if a valid email was entered
        if (!this.state.emailValid) {
            this.setState({emailErr: true});
            return;
        } else {
            this.setState({emailErr: true});
        }

        this.hideDialog();
        // Notify parent that the contact details have been entered.
        this.props.onClose && this.props.onClose({
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone
        });
    };

    render() {
        return (
            <Modal trigger={
                        <Button className='navy' floated='right' size='small' onClick={this.showDialog}>
                            {this.props.triggerLabel}
                            <Icon name='right chevron' />
                        </Button>}
                    closeIcon
                    size='mini' 
                    open={this.state.showDialog} 
                    onClose={this.hideDialog}>
                <Header icon='address card outline' content='Contact Details' />
                <Modal.Content>
                    <Input name='name' error={this.state.nameErr}
                        icon='user' iconPosition='left'
                        label={{ icon: 'asterisk' }} labelPosition='right corner'
                        placeholder='Name' fluid ={true}
                        onChange={this.onInputChange} />
                    <br />
                    <Input name='email' error={this.state.emailErr}
                        icon='mail' iconPosition='left'
                        label={{ icon: 'asterisk' }} labelPosition='right corner'
                        placeholder='Email' fluid ={true}
                        onChange={this.onInputChange} />
                    <br />
                    <Input name='phone'
                        icon='phone' iconPosition='left'
                        placeholder='Phone' fluid ={true} />

                </Modal.Content>
                <Modal.Actions>                    
                    <Button color='green' onClick={this.onComplete}>
                    <Icon name='checkmark' /> Send
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default ContactDetails;